<script>
import every from 'lodash/every'
import values from 'lodash/values'
import {
  deviceUserListComputed,
  deviceUserListMethods,
} from '@state/helpers/device-user-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, addParamsToLocation } from '@utils/helpers'
import cloneDeep from 'lodash/cloneDeep'
import tableFields from './tableFields'
import fieldsBoxCard from './fieldsBoxCard'

export default {
  page: {
    title: 'Device User List',
    meta: [{ name: 'description', content: 'The Device User List page.' }],
  },
  data() {
    return {
      items: {},
      searchBody: new SearchPayload.Builder()
        .withSearchMail()
        .withSearchDevicename()
        .withSearchMac(),
      fields: tableFields,
      filtered: false,
      openConfirm: false,
      deviceIdSelected: {},
      fieldsBoxCard: fieldsBoxCard,
      componentKey: 0,
    }
  },
  computed: {
    ...deviceUserListComputed,
    deviceUserListData() {
      const data = cloneDeep(this.getDeviceUserList?.list)?.map((item) => {
        item.device_id = item.id
        return item
      })
      return data
    },
    paginationComputed() {
      let paginations = {}
      if (this.getDeviceUserList) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getDeviceUserList
        )
      }
      return paginations
    },
    unselectedAll() {
      return every(values(this.deviceIdSelected), function(v) {
        return !v
      })
    },
    loadingComputed() {
      return this.loading
    },
    confirmComputed() {
      if (this.unselectedAll) {
        return 'unselected'
      }
      return 'delete'
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
      this.componentKey++
    },
  },
  created() {
    const filter = this.$route.query
    filter.page_no = parseInt(filter.page_no, 10)
    filter.lines = parseInt(filter.lines, 10)
    for (const key in filter) {
      if (key !== 'page_no' && key !== 'lines') {
        if (filter[key] !== '' && filter[key] !== undefined) {
          this.searchBody = filter
          this.filtered = true
        }
      }
    }
    if (filter.page_no > 1) {
      this.searchBody = filter
    }
    this.handleSearchDevice()
  },
  methods: {
    ...deviceUserListMethods,
    showModal() {
      this.openConfirm = !this.openConfirm
    },
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchDevice()
    },
    handleSorter(key) {
      this.searchBody = { ...this.searchBody, order_by: key }
      this.handleSearchDevice()
    },
    handleFilter(params, reset = false) {
      this.searchBody = { ...this.searchBody, ...params }
      this.handleSearchDevice()
      this.filtered = !reset
    },
    handleSearchDevice() {
      this.fetchingDeviceUserList(this.searchBody)
    },

    handleSelected(id, value) {
      const temp = { ...this.deviceIdSelected }
      temp[id] = value
      this.deviceIdSelected = { ...temp }
    },
    submit() {
      const temp = { ...this.deviceIdSelected }
      const flag = Object.keys(temp)?.map((key) => {
        if (temp[key]) {
          return key
        }
      })
      Promise.all(
        flag?.map((id) => {
          this.deleteDeviceById({ id })
        })
      ).then((rs) => {
        this.openConfirm = !this.openConfirm
        this.fetchingDeviceUserList(this.searchBody)
        this.deviceIdSelected = {}
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseFilterBoxCard
      :key="componentKey"
      :filter-value="searchBody"
      :fields="fieldsBoxCard"
      @filter="(p, r) => handleFilter(p, r)"
    />
    <BasePagination
      :paginations="paginationComputed"
      :searching="filtered"
      @activePagination="handlePagination"
    >
      <template v-slot:secondary>
        <CButton
          color="dark"
          variant="outline"
          class="py-0 ml-1"
          @click="showModal"
          >削除</CButton
        >
      </template>
    </BasePagination>
    <BaseTable
      striped
      border
      :loading="loadingComputed"
      :table-fields="fields"
      :data-tables="deviceUserListData"
      @sorterBy="handleSorter"
    >
      <template v-slot:checkbox="{ item }">
        <td class="py-2">
          <CInputCheckbox
            :checked="deviceIdSelected[item.device_id]"
            color="primary"
            @update:checked="(v) => handleSelected(item.device_id, v)"
          />
        </td>
      </template>
    </BaseTable>
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirm"
      :type="confirmComputed"
      :hide-action-button="unselectedAll"
      @closeModal="openConfirm = !openConfirm"
      @submit="submit"
    />
  </div>
</template>
